import React, { useState } from "react";
import "./ItemButton.css";
import { FaArrowRight, FaEarthAmericas, FaMoon } from "react-icons/fa6";
import { FaSun } from "react-icons/fa";
import TelegramText from "../Text/TelegramText";

function ItemButton({ item, handleButtonClick, type, isRecommended = false }) {
  const { title, image, descr, emoji } = item;

  const handleClick = () => {
    handleButtonClick(item);
  };

  // Helper function to render store icon (emoji or sprite)
  const renderStoreIcon = () => {
    if (type === "store" && emoji) {
      // Check if emoji is an image path
      if (emoji.startsWith('/')) {
        return (
          <img 
            src={emoji} 
            alt={title}
            className="store-sprite-icon"
            style={{ 
              width: '32px', 
              height: '32px', 
              imageRendering: 'pixelated',
              imageRendering: '-moz-crisp-edges',
              imageRendering: 'crisp-edges'
            }}
          />
        );
      } else {
        // Regular emoji
        return <span className="store-emoji-icon" style={{ fontSize: '32px' }}>{emoji}</span>;
      }
    }
    return null;
  };

  return (
    <div className={`itemcard ${isRecommended ? 'recommended-store' : ''}`}>
      <div className="btn-container">
        <button
          className={`telegramButton item__card__button ${isRecommended ? 'recommended-button' : ''}`}
          onClick={handleClick}
        >
          <div className="item__content">
            <div className="image__container">
              {type === "brand" ? (
                <FaSun />
              ) : type === "category" ? (
                <FaMoon />
              ) : type === "store" ? (
                renderStoreIcon()
              ) : (
                <FaEarthAmericas />
              )}
              {/* <img src={image} alt={title} /> */}
            </div>
            <TelegramText className="item__title">
              {type === "store" ? title : descr}
            </TelegramText>
            <div className="item__icon">
              <FaArrowRight />
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}

export default ItemButton;
